<template lang="html">
  <div class="tanfolyam-details-component">
    <v-container>
      <v-card>
        <v-container>
      <v-expansion-panels v-model="panel">
      <v-expansion-panel>
        <v-expansion-panel-header><b>Tanfolyam adatai</b></v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-form
            ref="course_details_form"
            v-model="valid"
            lazy-validation
          >
      <v-row>
        <v-col cols="12" md="4">
          <v-text-field
            v-model="course_number"
            label="Tanfolyam száma"
            outlined
            disabled
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="4">
          <v-select
            v-model="driving_school_id"
            :items="driving_schools"
            item-text="driving_school_name"
            item-value="driving_school_id"
            label="Autósiskola"
            :rules="[rules.required]"
            outlined
            :disabled="course_id != null"
          ></v-select>
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field
            v-if="!course_id"
            v-model="year"
            label="Tanfolyam indulás éve"
            outlined
            append-icon="date_range"
          ></v-text-field>
        </v-col>
        </v-row>
        <v-row>
        <v-col cols="12" md="4">
          <v-autocomplete
            v-model="place_id"
            :items="training_places"
            item-text="place_name"
            item-value="training_place_id"
            label="Tanfolyam helye"
            :rules="[rules.required]"
            outlined
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" md="4">
          <v-autocomplete
            v-model="course_pattern"
            :items="course_patterns"
            item-text="name"
            item-value="course_pattern_id"
            label="Tanfolyam sablon"
            :rules="[rules.required]"
            outlined
            :disabled="lessons != ''"
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" md="4">
          <v-autocomplete
            v-model="nkh_course_type_id"
            :items="nkh_course_types"
            item-text="soap_course_type_code"
            item-value="nkh_course_type_id"
            label="Tanfolyam típusa (NKH)"
            :rules="[rules.required]"
            outlined
            :loading="nkh_course_type_loader"
            :disabled="students && course_id != null"
          ></v-autocomplete>
        </v-col>
      </v-row>
      <v-row justify="center" v-if="course_id">
        <v-col cols="12" md="6">
          <v-text-field
            v-model="course_start"
            label="Első előadás"
            outlined
            disabled
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field
            v-model="course_end"
            label="Utolsó előadás"
            outlined
            disabled
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6" md="2">
          <v-btn
            v-if="!course_id"
            :disabled="!valid"
            color="primary"
            class="mr-4"
            @click="validate()"
            rounded
          >
          Rögzít
          </v-btn>
          <v-btn
            v-if="course_id"
            :disabled="!valid || course_archiv"
            color="primary"
            class="mr-4"
            @click="update_dialog = true"
            rounded
          >
          Módosít
          </v-btn>
          </v-col>
          <v-col cols="6" md="2">
            <v-btn
              v-if="course_id && !course_archiv"
              color="primary"
              class="mr-4"
              rounded
              @click="archvie_dialog = true"
            >
            Archivál
            </v-btn>
            <v-btn
              v-if="course_id && course_archiv && !nkh_head_id"
              color="primary"
              class="mr-4"
              rounded
              @click="active_dialog = true"
            >
            Aktivál
            </v-btn>
            </v-col>
            </v-row>
            <v-row>
            <v-col cols="6" md="2">
              <v-btn
                v-if="lessons != ''"
                color="primary"
                class="mr-4"
                @click="naplo()"
                rounded
              >
              Napló
              </v-btn>
            </v-col>
            <v-col cols="6" md="3" class="pt-0">
              <v-switch
                v-if="course_id"
                v-model="hidden"
                label="Nem publikus"
              ></v-switch>
            </v-col>
            <v-col md="3">
              <v-text-field
                v-if="course_id"
                v-model="public_limit"
                label="Meghirdetett létszám"
                v-mask="'##'"
                outlined
                dense
              ></v-text-field>
            </v-col>
          </v-row>
            <v-row>
            <v-col md="3">
            <v-btn
              v-if="course_id"
              color="primary"
              class="mr-4"
              rounded
              @click="tanrendUpload()"
              :disabled="uploading || course_archiv"
            >
            Tanrend feltöltés
            </v-btn>
            </v-col>
            <v-col md="3">
            <v-btn
              v-if="nkh_head_id && !gkiCheck"
              color="primary"
              class="mr-4"
              rounded
              @click="tanrendDownload()"
              target="_blank"
            >
            Tanrend letöltés
            </v-btn>
            <v-btn
              v-if="pallasz_id"
              color="primary"
              class="mr-4"
              rounded
              target="_blank"
              @click="pallaszDownload()"
            >
            Tanrend letöltés
            </v-btn>
            </v-col>
            </v-row>
            <v-row>
            <v-col md="3" v-if="!szimCheck">
            <v-btn
              v-if="pallasz_id"
              color="primary"
              class="mr-4"
              rounded
              @click="kokenyNevsorUpload()"
              :disabled="course_archiv || nevsor_uploading"
              :loading="nevsor_uploading"
            >
            Névsor feltöltés
            </v-btn>
            </v-col>
            <v-col md="5" v-if="szimCheck">
            <v-btn
              v-if="pallasz_id"
              color="primary"
              class="mr-4"
              rounded
              @click="gkiNevsorUpload()"
              :disabled="course_archiv || nevsor_uploading"
              :loading="nevsor_uploading"
            >
            Szimulátor névsor feltöltés
            </v-btn>
            </v-col>
            <v-col md="3">
            <v-btn
              v-if="roster_status == 'Uploaded' && pallasz_id"
              color="primary"
              class="mr-4"
              rounded
              @click="nevsorDownload()"
              target="_blank"
              :disabled="nevsor_downloading"
              :loading="nevsor_downloading"
            >
            Névsor letöltés
            </v-btn>
            </v-col>
        </v-row>
        <v-row v-if="course_id">
          <v-col md="4">
          <v-btn
            color="primary"
            class="mr-4"
            rounded
            outlined
            @click="megbizSzerz()"
          >
          Megbízási szerződés
          </v-btn>
          </v-col>
          <v-col md="4">
            <v-btn
              v-if="roster_status == 'Uploaded' && pallasz_id"
              color="red"
              class="mr-4 white--text"
              rounded
              @click="nevsorClose()"
              :disabled="nevsor_finalize_loader"
              :loading="nevsor_finalize_loader"
            >
            Névsor véglegesítés
            </v-btn>
            </v-col>
            <v-col md="3">
            <v-btn
              v-if="roster_status == 'Uploaded' && pallasz_id"
              color="red"
              class="mr-4 white--text"
              rounded
              @click="nevsorCloseBack()"
              :disabled="nevsor_finalize_loader"
              :loading="nevsor_finalize_loader"
            >
            véglegesítés visszavonása
            </v-btn>
            </v-col>
        </v-row>
        <v-row>
          <v-col md="4">
          <v-btn
            v-if="course_pattern == 90"
            color="green"
            class="mr-4"
            rounded
            outlined
            @click="euBefizetesek()"
          >
          Tanulói befizetések
          </v-btn>
          </v-col>
          <v-col md="4">
          <v-btn
            v-if="course_pattern == 90"
            color="green"
            class="mr-4"
            rounded
            outlined
            @click="euNaplo()"
          >
          EÜ jelenléti
          </v-btn>
          </v-col>
        </v-row>
        </v-form>
      </v-expansion-panel-content>
      </v-expansion-panel>
      </v-expansion-panels>
      <br>

      <v-layout justify-center>
      <v-slide-group
        v-show="course_id"
        v-model="tanfolyamok_tab"
        show-arrows
        mandatory
      >
      <v-slide-item v-slot:default="{ active, toggle }">
        <v-col cols="6">
        <v-btn
          text
          :input-value="active"
          active-class="orange--text"
          @click="toggle"
        >
          <span>Tanulók</span>
          <v-icon>account_circle</v-icon>
        </v-btn>
        </v-col>
      </v-slide-item>
      <v-slide-item v-slot:default="{ active, toggle }">
        <v-col cols="6">
        <v-btn
          text
          :input-value="active"
          active-class="orange--text"
          @click="toggle"
        >
          <span>Órák</span>
          <v-icon>alarm</v-icon>
        </v-btn>
        </v-col>
      </v-slide-item>
      </v-slide-group>
    </v-layout>

    <TanfolyamDiakok v-show="tanfolyamok_tab == 0 && course_id"></TanfolyamDiakok>
    <TanfolyamLessons v-show="tanfolyamok_tab == 1 && course_id"></TanfolyamLessons>

      </v-container>
      </v-card>
    </v-container>

    <v-dialog v-model="active_dialog" persistent max-width="350">
      <v-card>
        <v-card-text class="pt-4">Biztosan újra aktiválni szeretné a tanfolyamot?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="activeCourse(), active_dialog = false">Igen</v-btn>
          <v-btn color="primary" text @click="active_dialog = false">Nem</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="archvie_dialog" persistent max-width="350">
      <v-card>
        <v-card-text class="pt-4">Biztosan archiválni szeretné a tanfolyamot?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="archiveCourse(), archvie_dialog = false">Igen</v-btn>
          <v-btn color="primary" text @click="archvie_dialog = false">Nem</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="save_dialog" persistent max-width="320">
      <v-card>
        <v-card-text class="pt-4">Biztosan menteni szeretné a tanfolyamot?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="saveCourse(), save_dialog = false">Igen</v-btn>
          <v-btn color="primary" text @click="save_dialog = false">Nem</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="update_dialog" persistent max-width="350">
      <v-card>
        <v-card-text class="pt-4">Biztosan módosítani szeretné a tanfolyamot?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="updateCourse(), update_dialog = false">Igen</v-btn>
          <v-btn color="primary" text @click="update_dialog = false">Nem</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar" bottom>
      {{response_text}}
      {{upload_error}}
      {{upload_error_text}}
      {{tanrend_lemond}}
      <v-btn color="pink" text @click="snackbar = false">
        Bezár
      </v-btn>
    </v-snackbar>

  </div>
</template>

<script>
import store from '../store'
import TanfolyamDiakok from '../components/tanfolyamok_diakok.vue'
import TanfolyamLessons from '../components/tanfolyamok_lessons.vue'
import {
  mapFields
} from 'vuex-map-fields'

  export default {
    components: {
      TanfolyamDiakok,
      TanfolyamLessons,
    },
    data () {
      return {
        tanfolyamok_tab: null,
        panel: 0,
        training_places: [],
        course_patterns: [],
        driving_schools: [],
        nkh_course_types: [],
        rules: {
            required: value => !!value || 'Kötelező mező!',
          },
        valid: true,
        year: new Date().getFullYear(),
        place_limit: '',
        response_text: '',
        snackbar: false,
        archvie_dialog: false,
        active_dialog: false,
        save_dialog: false,
        upload_error: '',
        upload_error_text: '',
        tanrend_url: '',
        nkh_head_id: '',
        pallasz_id: '',
        roster_status: '',
        tanrend_lemond: '',
        nkh_course_type_loader: false,
        upload_status: '',
        update_dialog: false,
        response_html: '',
        eu_jelenleti_dialog: false,
        uploading: false,
        hidden: false,
        course_archiv: false,
        nevsor_uploading: false,
        nevsor_downloading: false,
        nevsor_finalize_loader: false,
        course_name: '',
      }
    },
    methods: {
      fetchCourseDetails: async function() {
        store.state.showing.preloader = true
        await this.gettoken()
        this.$http.post('/tanfolyamok/tanfolyamok_details', {
          token: this.token,
          course_id: this.course_id,
        }).then((response) => {
          store.state.showing.preloader = false
          this.course_number = response.data[0]['course_number'];
          this.course_start = response.data[0]['course_start'];
          this.course_end = response.data[0]['course_end'];
          this.place_name = response.data[0]['place_name'];
          this.place_id = response.data[0]['training_place_id'];
          this.course_type = response.data[0]['course_type'];
          this.course_name = response.data[0]['name'];
          this.course_pattern = response.data[0]['course_pattern'];
          this.driving_school_id = response.data[0]['driving_school_id'];
          this.nkh_user_name = response.data[0]['nkh_user_name'];
          this.course_type_id = response.data[0]['course_type_id'];
          this.nkh_course_type_id = response.data[0]['nkh_course_type_id'];
          this.place_limit = response.data[0]['place_limit'];
          this.nkh_head_id = response.data[0]['nkh_head_id'];
          this.pallasz_id = response.data[0]['pallasz_id'];
          this.tanrend_url = response.data[1]+response.data[0]['nkh_head_id']+"/pdf";
          this.roster_status = response.data[0]['roster_status'];
          this.upload_status = response.data[0]['status'];
          this.hidden = response.data[0]['hidden'];
          this.public_limit = response.data[0]['public_limit'];
          this.course_archiv = response.data[0]['archive'];
        }, (error) => {
          this.error_text = error.data
        })
      },
      saveCourse: async function() {
        store.state.showing.preloader = true
        await this.gettoken()
        this.$http.post('/tanfolyamok/save_course', {
          token: this.token,
          driving_school_id: this.driving_school_id,
          year: this.year,
          place_id: this.place_id,
          nkh_course_type_id: this.nkh_course_type_id,
          course_pattern: this.course_pattern
        }).then((response) => {
          store.state.showing.preloader = false
          this.course_id = response.data[1]
          this.response_text = response.data[0]
          this.snackbar = true

        }, (error) => {
          this.error_text = error.data
        })
      },
      updateCourse: async function() {
        store.state.showing.preloader = true
        await this.gettoken()
        this.$http.post('/tanfolyamok/update_course_210420', {
          token: this.token,
          course_id: this.course_id,
          place_id: this.place_id,
          nkh_course_type_id: this.nkh_course_type_id,
          course_pattern: this.course_pattern,
          hidden: this.hidden,
          public_limit: this.public_limit
        }).then((response) => {
          store.state.showing.preloader = false
          this.response_text = response.data
          this.snackbar = true
          this.fetchCourseDetails()
        }, (error) => {
          this.error_text = error.data
        })
      },
      archiveCourse: async function() {
        store.state.showing.preloader = true
        await this.gettoken()
        this.$http.post('/tanfolyamok/archive_course', {
          token: this.token,
          course_id: this.course_id,
          nkh_head_id: this.nkh_head_id,
        }).then((response) => {
          this.$eventBus.$emit('archive_course_result', response.data);
          store.state.showing.preloader = false
          this.Tanfolyamok_show = true
          this.TanfolyamokDetails_show = false

        }, (error) => {
          this.error_text = error.data
        })
      },
      activeCourse: async function() {
        store.state.showing.preloader = true
        await this.gettoken()
        this.$http.post('/tanfolyamok/active_course', {
          token: this.token,
          course_id: this.course_id,
          nkh_head_id: this.nkh_head_id,
        }).then((response) => {
          this.$eventBus.$emit('archive_course_result', response.data);
          store.state.showing.preloader = false
          this.Tanfolyamok_show = true
          this.TanfolyamokDetails_show = false

        }, (error) => {
          this.error_text = error.data
        })
      },
      getPlaces: async function() {
        store.state.showing.preloader = true
        await this.gettoken()
        this.$http.post('/tanfolyamok/training_places', {
          token: this.token,
        }).then((response) => {
          store.state.showing.preloader = false
          this.training_places = response.data

        }, (error) => {
          this.error_text = error.data
        })
      },
      getCoursePatterns: async function() {
        store.state.showing.preloader = true
        await this.gettoken()
        this.$http.post('/tanfolyamok/course_patterns', {
          token: this.token,
        }).then((response) => {
          store.state.showing.preloader = false
          this.course_patterns = response.data

        }, (error) => {
          this.error_text = error.data
        })
      },
      getDrivingSchool: async function() {
        store.state.showing.preloader = true
        await this.gettoken()
        this.$http.post('/tanfolyamok/driving_schools', {
          token: this.token,
        }).then((response) => {
          store.state.showing.preloader = false
          this.driving_schools = response.data

        }, (error) => {
          this.error_text = error.data
        })
      },
      getNKHCourseTypes: async function() {
        store.state.showing.preloader = true
        await this.gettoken()
        this.$http.post('/tanfolyamok/nkh_course_types_by_school', {
          token: this.token,
          driving_school_id: this.driving_school_id
        }).then((response) => {
          store.state.showing.preloader = false
          this.nkh_course_types = response.data
        }, (error) => {
          this.error_text = error.data
        })
      },
      tanrendUpload: async function() {
        this.uploading = true
        this.preloader = true
        await this.gettoken()
        this.$http.post('/kokeny/tanfolyam_upload', {
          token: this.token,
          course_id: this.course_id
        }).then((response) => {
          this.preloader = false
          this.uploading = false
          this.response_text = response.data['result']
          this.upload_error = response.data['message']
          this.snackbar = true
          this.fetchCourseDetails()

        }, (error) => {
          this.preloader = false
          this.uploading = false
          this.error_text = error.data
        })
      },
      pallaszUpload: async function() {
        this.preloader = true
        await this.gettoken()
        this.$http.post('/tanfolyamok/pallasz/tanfolyam', {
          token: this.token,
          course_number: this.course_number,
          course_id: this.course_id
        }).then((response) => {
          this.preloader = false
          this.response_text = response.data['result']
          this.upload_error = response.data['message']
          this.upload_error_text = response.data['else']
          this.snackbar = true
          this.fetchCourseDetails()
        }, (error) => {
          this.error_text = error.data
        })
      },
      pallaszDownload: async function() {
        this.preloader = true
        await this.gettoken()
        this.$http.post('/kokeny/tanrend_print', {
          token: this.token,
          course_id: this.course_id,
        }, {responseType: 'blob'}).then((response) => {
          this.preloader = false
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', this.course_number+'_tanrend.pdf');
          document.body.appendChild(link);
          link.click();
        }, (error) => {
          this.error_text = error.data
        })
      },
      tanrendDownload: async function() {
        this.preloader = true
        await this.gettoken()
        this.$http.post('/tanfolyamok/tanrend_download', {
          token: this.token,
          course_id: this.pallasz_id,
          nkh_head_id: this.nkh_head_id,
          driving_school_id: this.driving_school_id
        }, {responseType: 'blob'}).then((response) => {
          this.preloader = false
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', this.course_number+'_tanrend.pdf');
          document.body.appendChild(link);
          link.click();
        }, (error) => {
          this.error_text = error.data
        })
      },
      nevsorUpload: async function() {
        this.preloader = true
        await this.gettoken()
        if (!this.gkiCheck) {
          this.$http.post('/tanfolyamok/nevsor_upload', {
            token: this.token,
            course_id: this.course_id
          }).then((response) => {
            this.preloader = false
            this.response_text = response.data['result']
            this.snackbar = true
            this.fetchCourseDetails()
          }, (error) => {
            this.error_text = error.data
          })
        } else if (this.gkiCheck) {
          this.$http.post('/tanfolyamok/pallasz/nevsor_upload', {
            token: this.token,
            course_id: this.pallasz_id
          }).then((response) => {
            this.preloader = false
            this.response_text = response.data['result']
            this.snackbar = true
            this.fetchCourseDetails()
          }, (error) => {
            this.error_text = error.data
          })
        }
      },
      kokenyNevsorUpload: async function() {
        this.nevsor_uploading = true
        await this.gettoken()
          this.$http.post('/kokeny/tanfolyam_add_student', {
            token: this.token,
            course_id: this.course_id
          }).then((response) => {
            this.nevsor_uploading = false
            this.response_text = response.data['result']
            this.upload_error = response.data['error']
            this.snackbar = true
            this.fetchCourseDetails()
          }, (error) => {
            this.nevsor_uploading = false
            this.error_text = error.data
          });
      },
      tanuloAzMod: async function() {
        this.nevsor_uploading = true
        await this.gettoken()
          this.$http.post('/kokeny/tanfolyam_gki_stud_id_mod', {
            token: this.token,
            course_id: this.course_id
          }).then((response) => {
            console.log(response.data);    
          }, (error) => {
            this.nevsor_uploading = false
            this.error_text = error.data
          });
      },
      gkiNevsorUpload: async function() {
        this.nevsor_uploading = true
        await this.gettoken()
          this.$http.post('/kokeny/tanfolyam_add_gki_student', {
            token: this.token,
            course_id: this.course_id
          }).then((response) => {
            this.nevsor_uploading = false
            this.response_text = response.data['result']
            this.upload_error = response.data['error']
            this.snackbar = true
            this.fetchCourseDetails()
          }, (error) => {
            this.nevsor_uploading = false
            this.error_text = error.data
          });
      },
      nevsorDownload: async function() {
        this.nevsor_downloading = true
        await this.gettoken()
          this.$http.post('/kokeny/nevsor_print', {
            token: this.token,
            course_id: this.course_id,
          }, {responseType: 'blob'}).then((response) => {
            this.nevsor_downloading = false
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', this.course_number+'_nevsor.pdf');
            document.body.appendChild(link);
            link.click();
          }, (error) => {
            this.nevsor_downloading = false
            this.error_text = error.data
          })   
      },
      nevsorClose: async function() {
        this.nevsor_finalize_loader = true
        await this.gettoken()
        this.$http.post('/kokeny/tanfolyam_nevsor_finalize', {
          token: this.token,
          course_id: this.course_id
        }).then((response) => {
          this.nevsor_finalize_loader = false
          this.response_text = response.data;
          this.upload_error = response.data['message']
          this.snackbar = true
          this.fetchCourseDetails()
        }, (error) => {
          this.nevsor_finalize_loader = false
          this.error_text = error.data
        })
      },
      nevsorCloseBack: async function() {
        this.nevsor_finalize_loader = true
        await this.gettoken()
        this.$http.post('/kokeny/tanfolyam_nevsor_finalize_back', {
          token: this.token,
          course_id: this.course_id
        }).then((response) => {
          this.nevsor_finalize_loader = false
          this.response_text = response.data;
          this.upload_error = response.data['message']
          this.snackbar = true
          this.fetchCourseDetails()
        }, (error) => {
          this.nevsor_finalize_loader = false
          this.error_text = error.data
        })
      },
      euJelenleti: async function() {
        this.preloader = true
        await this.gettoken()
        this.$http.post('/tanfolyamok/elsosegely/lista', {
          token: this.token,
          course_number: this.course_number
        }).then((response) => {
          var w = window.open();
          w.document.open();
          w.document.write(response.data);
          w.document.close();
          this.preloader = false
        }, (error) => {
          this.error_text = error.data
        })
      },
      euBefizetesek: async function() {
        this.preloader = true
        await this.gettoken()
        this.$http.post('/tanfolyamok/elsosegely/befizetes', {
          token: this.token,
          course_number: this.course_number
        }).then((response) => {
          var w = window.open();
          w.document.open();
          w.document.write(response.data);
          w.document.close();
          this.preloader = false
        }, (error) => {
          this.error_text = error.data
        })
      },
      validate () {
        if (this.$refs.course_details_form.validate()) {
          this.save_dialog = true
          }
        },
        resetValidation () {
          this.$refs.course_details_form.resetValidation()
        },
        coursePatternAssoc: async function() {
          this.nkh_course_type_loader = true
          await this.gettoken()
          this.$http.post('/tanfolyamok/coursePatternAssoc', {
            token: this.token,
            course_pattern: this.course_pattern
          }).then((response) => {
            this.nkh_course_type_loader = false
            this.nkh_course_type_id = response.data[0]['nkh_type']

          }, (error) => {
            this.error_text = error.data
          })
        },
        megbizSzerz: async function() {
          this.preloader = true
          await this.gettoken()
          this.$http.post('/tanfolyamok/megbizasi/szerzodes', {
            token: this.token,
            course_id: this.course_id
          }).then((response) => {
            this.preloader = false
            console.log(response.data);
            response.data.forEach((url) => {
                window.open(url);
            });
          }, (error) => {
            this.error_text = error.data
          })
        },
        naplo: async function() {
          store.state.showing.preloader = true
          await this.gettoken()
          $.ajax({
            url: this.$url+"/tanfolyamok/naplo/naplo_220503",
            method: 'POST',
            data: {
              'token': this.token,
              'course_id': this.course_id,
            },
            xhrFields: {
              responseType: 'blob'
            },
          }).then((response) => {
            store.state.showing.preloader = false
              var a = document.createElement('a');
              var url = window.URL.createObjectURL(response);
              a.href = url;
              a.download = this.course_number;
              document.body.appendChild(a);
              a.click();
              window.URL.revokeObjectURL(url);
          }, (error) => {
            console.log(error);
          })
        },
        euNaplo: async function() {
          store.state.showing.preloader = true
          await this.gettoken()
          $.ajax({
            url: this.$url+"/tanfolyamok/naplo/eu_jelenleti",
            method: 'POST',
            data: {
              'token': this.token,
              'course_id': this.course_id,
            },
            xhrFields: {
              responseType: 'blob'
            },
          }).then((response) => {
            store.state.showing.preloader = false
              var a = document.createElement('a');
              var url = window.URL.createObjectURL(response);
              a.href = url;
              a.download = this.course_start+"_EÜ_jelenléti";
              document.body.appendChild(a);
              a.click();
              window.URL.revokeObjectURL(url);
          }, (error) => {
            console.log(error);
          })
        },
    },
    mounted() {
      //this.fetchCourseDetails();
      this.getPlaces();
      this.getCoursePatterns();
      this.getDrivingSchool()
    },
    watch: {
      lessons: function (value) {
          this.fetchCourseDetails();
      },
      course_id: function (value) {
          this.fetchCourseDetails();
      },
      course_number: function (value) {
          this.resetValidation()
      },
      course_pattern: function (value) {
        if (this.course_id == null) {
          this.coursePatternAssoc()
        }
      },
      tanrend_upload: function (value) {
        if (value == true && this.upload_status == 'Uploaded') {
          this.tanrendUpload()
        }
      },
      nevsor_upload: function (value) {
        if (value == true && this.roster_status == 'Uploaded') {
          this.nevsorUpload()
        }
      },
      driving_school_id() {
        this.getNKHCourseTypes()
      },
      gkiCheck(value) {
        if (value == true) {
          this.is_GKI = true
        } else {
          this.is_GKI = false
        }
      }
    },
    computed: {
    ...mapFields([
    'auth.admin',
    'tanfolyamok.course_id',
    'tanfolyamok.course_number',
    'tanfolyamok.course_start',
    'tanfolyamok.course_end',
    'tanfolyamok.place_name',
    'tanfolyamok.place_id',
    'tanfolyamok.course_type',
    'tanfolyamok.course_type_id',
    'tanfolyamok.nkh_course_type_id',
    'tanfolyamok.course_pattern',
    'tanfolyamok.lessons',
    'tanfolyamok.driving_school_id',
    'tanfolyamok.nkh_user_name',
    'tanfolyamok.tanrend_upload',
    'tanfolyamok.nevsor_upload',
    'tanfolyamok.students',
    'tanfolyamok.public_limit',
    'course_details.is_GKI',
    'showing.Tanfolyamok_show',
    'showing.TanfolyamokDetails_show',
    'showing.preloader',
    ]),
    gkiCheck: function () {
      if (this.course_id) {
        if (this.course_type.includes("GKI")) {
          return true
          }
        }
      },
    szimCheck: function () {
      if (this.course_id) {
        if (this.course_name.includes("SZIM")) {
          return true
          }
        }
      }
    },
  }
</script>

<style lang="css">
</style>
